import React from 'react';
import Globe from 'lucide-react/dist/esm/icons/globe';

const LandingNavbar = ({ t, i18n, toggleLanguage, navigate }) => {
  return (
    <nav className="sticky top-0 z-50 px-4 py-3" style={{ backgroundColor: '#F9F9F6', borderBottom: '2px solid #2C2C2C', paddingTop: 'max(0.5rem, env(safe-area-inset-top, 0.5rem))' }}>
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img 
              src="/zensaver-logo-new.png" 
              alt="Zensaver" 
              className="h-10 w-auto" 
              fetchpriority="high"
              loading="eager"
            />
          </div>
          <div className="flex items-center gap-3">
            {/* Language Toggle */}
            <button
              onClick={toggleLanguage}
              data-testid="navbar-language-btn"
              className="flex items-center gap-1 px-3 py-2 rounded-lg font-semibold transition-all hover:scale-105"
              style={{ 
                backgroundColor: 'transparent', 
                color: '#2C2C2C',
                fontFamily: "'Patrick Hand', cursive",
                fontSize: '0.95rem',
                border: '2px solid #2C2C2C'
              }}
              title={i18n.language === 'es' ? 'Switch to English' : 'Cambiar a Español'}
            >
              <Globe className="w-4 h-4" />
              <span>{i18n.language === 'es' ? 'EN' : 'ES'}</span>
            </button>
            <button
              onClick={() => navigate('/login')}
              data-testid="navbar-login-btn"
              className="px-4 py-2 rounded-lg font-semibold transition-all hover:scale-105"
              style={{ 
                backgroundColor: 'transparent', 
                color: '#27AE60',
                fontFamily: "'Patrick Hand', cursive",
                fontSize: '1.1rem',
                border: '2px solid #27AE60'
              }}
            >
              {t('landing.nav.login')}
            </button>
            <button
              onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}
              data-testid="navbar-pricing-btn"
              className="px-4 py-2 rounded-lg font-semibold transition-all hover:scale-105"
              style={{ 
                backgroundColor: '#27AE60', 
                color: 'white',
                fontFamily: "'Patrick Hand', cursive",
                fontSize: '1.1rem',
                border: '2px solid #27AE60'
              }}
            >
              {t('landing.pricing.viewPlans')}
            </button>
          </div>
        </div>
      </nav>
  );
};

export default LandingNavbar;
